import Dexie from 'dexie';

// Create a new Dexie database instance. This is our "connection".
export const localDb = new Dexie('myDriveOfflineFiles');

// Define the database schema (the 'tables' or 'object stores')
localDb.version(1).stores({
  files: 'id, name, fileBlob' // 'files' is the table name
                              // 'id' is the unique key (we'll use the Firestore doc ID)
                              // 'name' is the filename (useful for offline search later)
                              // 'fileBlob' is where we'll store the actual file data
});